import styled, { css, keyframes } from "styled-components";

import { IContainerStyleProps, IContentStyleProps } from "./interfaces"; 

const openModal = keyframes`
    0% {
        opacity: 0;
    }

    100% {
        opacity: 1;
    }
`;

export const Container = styled.div<IContainerStyleProps>`
    background-color: ${p => p.theme.c.blackShadow35};
    ${p =>
        p.overflowHidden &&
        css`
            overflow: hidden;
        `}
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 100;
    animation: ${openModal} 0.3s;
`;

export const Overlay = styled.div`
    position: absolute;
    top: auto;
    left: auto;
    right: auto;
    bottom: auto;
    border: none;
    background: transparent;
    overflow-x: auto;
    overflow-y: scroll;
    border-radius: 4px;
    outline: none;
    padding: 0;
    width: 100%;
    height: 100%;
`;

export const HorizontalAlign = styled.div`
    margin: auto;
    position: relative;
    ${p =>
        p.theme.sm.min(css`
            display: table;
        `)}
    height: 100%;
    max-width: 424px;
    @media not all and (min-resolution: 0.001dpcm) {
        max-width: 100%;
        width: 424px;
    }
`;

export const VerticalAlign = styled.div`
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
    position: relative;
    box-sizing: border-box;

    ${p =>
        p.theme.sm.min(css`
            padding: 20px 0;
        `)}
`;

export const Content = styled.div<IContentStyleProps>`
    ${p =>
        p.theme.xs(css`
            padding: 18px;
            width: calc(100vw - 60px) !important;
            margin: 12px auto;
        `)}

    ${p =>
        p.theme.sm.min(css`
            padding: 24px;
            margin: 12px;
            width: 352px;
        `)}
    background-color: ${p => p.theme.c.snow};
    position: relative;
    border-radius: ${p => (p.noBorderRadius ? 0 : 8)}px;

    box-shadow: 0 3px 9px ${p => p.theme.c.blackShadow5};

    form {
        margin-bottom: 0;
        *:last-child {
            margin-bottom: 0;
        }
    }
`;

export const CloseButton = styled.div`
    position: absolute;
    top: 12px;
    right: 12px;
    width: 38px;
    height: 38px;
    text-align: center;
    font-size: 38px;
    line-height: 38px;
    color: ${p => p.theme.c.disabled};
    cursor: pointer;
    z-index: 1;
`;
